// @ts-nocheck
import axios from './axios';
import store from '../redux/store';
import jwtDecode from 'jwt-decode';
import { getCurrentUser } from '../redux/actions/auth';
import ROUTES, { findMatchedMenu, MENUS } from './routes';
import axios2 from './axios-2';
import Cookies from 'js-cookie';

export const setAuthToken = token => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios2.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    Cookies.set('obs-token', token, {
        domain: process.env.NODE_ENV === 'development' ? undefined : process.env.REACT_APP_BASE_DOMAIN,
        expires: 1, // 1 day
    });
};

export const deleteAutToken = () => {
    delete axios.defaults.headers.common['Authorization'];
    delete axios2.defaults.headers.common['Authorization'];
    Cookies.remove('obs-token');
};

export const saveLastPath = pathname => {
    localStorage.setItem('lastPath', pathname);
};

export const getLastPath = () => localStorage.getItem('lastPath');

export const removeLastPath = () => {
    localStorage.removeItem('lastPath');
};

export const checkCurrentUser = async () => {
    const token = Cookies.get('obs-token');

    if (token) {
        if (isTokenExpired(token)) {
            return null;
        } else {
            setAuthToken(token);

            const user = await store.dispatch(getCurrentUser());

            return user;
        }
    } else {
        return null;
    }
};

export const redirectToLogin = () => {
    deleteAutToken();
    saveLastPath(window.location.pathname + window.location.search);

    if (window.location.pathname !== ROUTES.LOGIN.path) {
        window.location.replace(ROUTES.LOGIN.path);
    }
};

export const getMatchedOrFirstAccessibleMenuPath = (pathname, userRoles) => {
    const accessibleMenuIds = Object.keys(userRoles).map(id => Number(id));

    if (!pathname || pathname === '/') {
        return getFirstAccessibleMenuPath(accessibleMenuIds);
    }

    const matchedMenu = findMatchedMenu(pathname);

    if (matchedMenu) {
        if (!matchedMenu.subMenus) {
            if (accessibleMenuIds.includes(matchedMenu.id)) {
                return matchedMenu.fullPath ?? matchedMenu.path;
            } else {
                return getFirstAccessibleMenuPath(accessibleMenuIds);
            }
        } else {
            const matchedSubMenu = Object.values(MENUS).find(
                menu => !menu.subMenus && matchedMenu.subMenus.includes(menu.id) && accessibleMenuIds.includes(menu.id),
            );

            return matchedSubMenu.fullPath ?? matchedSubMenu.path;
        }
    } else {
        return getFirstAccessibleMenuPath(accessibleMenuIds);
    }
};

const isTokenExpired = token => {
    const decoded = jwtDecode(token);

    return decoded.exp * 1000 <= Date.now();
};

const getFirstAccessibleMenuPath = accessibleMenus => {
    let menuPath;

    const firstAccessibleMenu = Object.values(MENUS).find(menu => !menu.subMenus && accessibleMenus.includes(menu.id));

    if (!firstAccessibleMenu) {
        menuPath = ROUTES.LOGIN.path;
    } else {
        menuPath = firstAccessibleMenu.fullPath ?? firstAccessibleMenu.path;
    }

    return menuPath;
};
